/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
// @material-ui/core components
import { red } from '@material-ui/core/colors';
import axios from 'axios';
import {
    Button,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper, TableSortLabel, TableFooter, TablePagination,
} from '@material-ui/core';

import { makeStyles } from '@material-ui/core/styles';

import {
    Modal, ModalHeader, ModalBody
} from 'reactstrap';

// core components
import Grid from "components/Grid/GridContainer";
import Col from "components/Grid/GridItem";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import Button2 from "components/CustomButtons/Button.js";
import TSText from "components/Forms/TSText";
import TSSelectMultiple from "components/Forms/TSSelectMultiple";
import "react-datetime/css/react-datetime.css"
import "./custom-style.css";

const useStyles = makeStyles((theme) => ({
    cardTitleWhite: {
        color: "#FFFFFF",
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "300",
        fontFamily: '"Sarabun", sans-serif',
        marginBottom: "3px",
        textDecoration: "none",
        flexGrow: 1,
    },
    tableContainer: {
        width: '99.99%',
        overflowX: 'auto',
    },
    tableRow: {
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover,
        },
    },
    tableCell: {
        padding: '2px',
    },
}));

const ORConsentFileList = (props) => {
    const tableText = 'จัดการ Report Template'; // เปลี่ยนชื่อหัวข้อ
    const classes = useStyles();

    const [dataList, setDataList] = useState([]); // รายการ Template
    const [groupOptions, setGroupOptions] = useState([]); // รายการ Group ทั้งหมดสำหรับ Dropdown

    // State สำหรับ Form
    const [selectedData, setSelectedData] = useState(null);
    const [selectedGroups, setSelectedGroups] = useState([]); // เก็บค่าที่เลือกใน Dropdown (Array of Objects)

    // Pagination & Sort
    const [orderDirection, setOrderDirection] = useState('desc');
    const [orderBy, setOrderBy] = useState('code');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(25);

    // Modal & Status
    const [modalOpen, setModalOpen] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [Keyword, setKeyword] = useState('');

    useEffect(() => {
        fetchDataList();
        fetchGroupOptions(); // โหลดข้อมูล Group มารอไว้สำหรับ Dropdown
    }, [Keyword]);

    // 1. ดึงข้อมูล Report Template ทั้งหมด (API ใหม่)
    const fetchDataList = async () => {
        try {
            // เรียกไปที่ Controller: ReportTemplateController
            const response = await axios.get(`/api/v1/report/template`);
            if (response.data) {
                let filtered = response.data;
                // Client-side filtering
                if (Keyword) {
                    filtered = filtered.filter(x =>
                        (x.name && x.name.toLowerCase().includes(Keyword.toLowerCase())) ||
                        (x.code && x.code.toLowerCase().includes(Keyword.toLowerCase()))
                    );
                }
                setDataList(filtered);
            } else {
                setDataList([]);
            }
        } catch (error) {
            console.error('Error fetching dataList:', error);
            setDataList([]);
        }
    };

    // 2. ดึงข้อมูล Master Group (API เดิม)
    const fetchGroupOptions = async () => {
        try {
            const response = await axios.get(`/api/v1/consent/orgroup`);
            if (response.data) {
                // แปลงข้อมูลให้เป็น Format { value, label } สำหรับ TSSelectMultiple
                const options = response.data.map(item => ({
                    value: item.orGroupKey,
                    label: item.name + ' (' + item.code + ')'
                }));
                setGroupOptions(options);
            }
        } catch (error) {
            console.error('Error fetching groups:', error);
        }
    };

    const handleRequestSort = (property) => {
        const isAsc = orderBy === property && orderDirection === 'asc';
        setOrderDirection(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const sortedData = () => {
        return dataList.sort((a, b) => {
            if (orderDirection === 'asc') {
                return a[orderBy] < b[orderBy] ? -1 : 1;
            }
            return a[orderBy] > b[orderBy] ? -1 : 1;
        });
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleCloseModal = () => {
        setModalOpen(false);
        setSelectedData(null);
        setSelectedGroups([]); // Reset Dropdown
        setIsEditing(false);
    };

    const handleAdd = () => {
        clearForm();
        setModalOpen(true);
    };

    const clearForm = () => {
        // เตรียม Object ให้ตรงกับ ReportTemplate Model
        setSelectedData({
            code: '',
            name: '',
            rdlcPath: '', // เปลี่ยนจาก reportFileName เป็น rdlcPath
            // fileUrl: '', // Model ใหม่ไม่มี field นี้ ตัดออก
            orGroupKeys: []
        });
        setSelectedGroups([]);
    };

    // เปิด Modal Edit พร้อม Map ข้อมูล Group เดิม
    const handleEdit = (data) => {
        setIsEditing(true);
        setSelectedData(data);

        // Map ORConsentGroups -> Dropdown Options
        // data.orConsentGroups ได้มาจาก .Include ใน Controller
        if (data.orConsentGroups && data.orConsentGroups.length > 0) {
            const currentGroups = data.orConsentGroups.map(g => ({
                value: g.orGroupKey,
                label: g.orGroup ? g.orGroup.name : ''
            }));
            setSelectedGroups(currentGroups);
        } else {
            setSelectedGroups([]);
        }

        setModalOpen(true);
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setSelectedData({ ...selectedData, [name]: value });
    };

    // จัดการเมื่อเลือก Dropdown Group (Multi Select)
    const handleGroupChange = (selectedOptions) => {
        setSelectedGroups(selectedOptions || []);
    };

    const handleSaveChanges = async () => {
        try {
            // เตรียม Payload
            const payload = {
                ...selectedData,
                // แปลง Object Dropdown กลับเป็น List<int> ส่งให้ Backend
                orGroupKeys: selectedGroups.map(x => x.value)
            };

            if (isEditing) {
                // PUT: ใช้ templateId
                await axios.put('/api/v1/report/template/' + selectedData.templateId, payload);
            } else {
                // POST
                await axios.post('/api/v1/report/template', payload);
            }
            handleCloseModal();
            fetchDataList(); // โหลดข้อมูลใหม่
        } catch (error) {
            console.error("Error updating data:", error);
            alert("เกิดข้อผิดพลาดในการบันทึกข้อมูล");
        }
    };

    // ฟังก์ชันลบข้อมูล
    const handleDelete = async (id) => {
        if (window.confirm("คุณต้องการลบข้อมูลนี้ใช่หรือไม่?")) {
            try {
                // DELETE: ใช้ templateId
                await axios.delete('/api/v1/report/template/' + id);
                fetchDataList();
            } catch (error) {
                console.error("Error deleting:", error);
            }
        }
    }

    return (
        <div>
            <Card>
                <CardHeader color="primary">
                    <h4 className={classes.cardTitleWhite}>รายการ{tableText}</h4>
                </CardHeader>
                <CardBody>
                    <div>
                        <Grid>
                            <Col xs={12} sm={12} md={12}>
                                <TSText icon="far fa-edit" label="คำค้นหา" value={Keyword} onChange={e => setKeyword(e.target.value)} />
                            </Col>
                        </Grid>

                        <Col xs={12} sm={12} md={12} style={{ textAlign: 'right' }}>
                            <Button2
                                color="success"
                                type="button"
                                onClick={handleAdd}
                            >
                                <h4><i className={"fa fa-plus"}> เพิ่ม{tableText}</i></h4>
                            </Button2>
                        </Col>
                        <TableContainer component={Paper} className={classes.tableContainer}>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>
                                            <TableSortLabel
                                                active={orderBy === 'code'}
                                                direction={orderBy === 'code' ? orderDirection : 'asc'}
                                                onClick={() => handleRequestSort('code')}
                                            >
                                                รหัส
                                            </TableSortLabel>
                                        </TableCell>
                                        <TableCell>
                                            <TableSortLabel
                                                active={orderBy === 'name'}
                                                direction={orderBy === 'name' ? orderDirection : 'asc'}
                                                onClick={() => handleRequestSort('name')}
                                            >
                                                ชื่อ Template
                                            </TableSortLabel>
                                        </TableCell>
                                        <TableCell>RDLC Path</TableCell>
                                        <TableCell>จัดการ</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {sortedData()
                                        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                        .map((data, index) => (
                                            <TableRow key={index} className={classes.tableRow}>
                                                <TableCell>
                                                    <Button style={{ textDecoration: 'underline' }} onClick={() => handleEdit(data)}>
                                                        {data.code}
                                                    </Button>
                                                </TableCell>
                                                <TableCell>{data.name}</TableCell>
                                                <TableCell>{data.rdlcPath}</TableCell>
                                                <TableCell>
                                                    <Button2 color="warning" size="sm" onClick={() => handleEdit(data)}>
                                                        <i className="fa fa-edit" />
                                                    </Button2>
                                                    {' '}
                                                    {/* ส่ง templateId ไปลบ */}
                                                    <Button2 color="danger" size="sm" onClick={() => handleDelete(data.templateId)}>
                                                        <i className="fa fa-trash" />
                                                    </Button2>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                </TableBody>
                                <TableFooter>
                                    <TableRow>
                                        <TablePagination
                                            rowsPerPageOptions={[5, 10, 25]}
                                            count={dataList.length}
                                            rowsPerPage={rowsPerPage}
                                            page={page}
                                            onPageChange={handleChangePage}
                                            onRowsPerPageChange={handleChangeRowsPerPage}
                                        />
                                    </TableRow>
                                </TableFooter>
                            </Table>
                        </TableContainer>
                    </div>
                </CardBody>
                <CardFooter>
                    <Modal isOpen={modalOpen} toggle={handleCloseModal} size="lg">
                        <ModalHeader toggle={handleCloseModal}></ModalHeader>
                        <ModalBody>
                            {selectedData && (
                                <Card>
                                    <CardHeader color="primary">
                                        <h4 className={classes.cardTitleWhite}>
                                            {isEditing ? `แก้ไข ${tableText}` : `เพิ่ม ${tableText}`}
                                        </h4>
                                    </CardHeader>
                                    <CardBody>
                                        <Grid>
                                            <Col xs={12} sm={6}>
                                                <TSText
                                                    icon="far fa-edit"
                                                    name="code"
                                                    label="รหัส Template"
                                                    value={selectedData.code}
                                                    onChange={handleInputChange}
                                                />
                                            </Col>
                                            <Col xs={12} sm={12}>
                                                <TSText
                                                    icon="far fa-edit"
                                                    name="name"
                                                    label="ชื่อ Template"
                                                    value={selectedData.name}
                                                    onChange={handleInputChange}
                                                />
                                            </Col>
                                            <Col xs={12} sm={12}>
                                                <TSText
                                                    icon="far fa-file"
                                                    name="rdlcPath" // เปลี่ยนชื่อ Field ให้ตรงกับ Model
                                                    label="RDLC Path (เช่น Reports/MyReport.rdlc)"
                                                    value={selectedData.rdlcPath}
                                                    onChange={handleInputChange}
                                                />
                                            </Col>

                                            <Col xs={12} sm={12}>
                                                {/* Dropdown Multi-Select */}
                                                <TSSelectMultiple
                                                    label="จับคู่กลุ่ม (OR Groups)"
                                                    options={groupOptions}
                                                    value={selectedGroups}
                                                    onChange={handleGroupChange}
                                                />
                                            </Col>
                                        </Grid>
                                    </CardBody>
                                    <CardFooter>
                                        <Button2 color="info" type="button" onClick={handleSaveChanges}>
                                            <h4>บันทึก</h4>
                                        </Button2>
                                        <Button2 color="danger" type="button" onClick={handleCloseModal}>
                                            <h4>ยกเลิก</h4>
                                        </Button2>
                                    </CardFooter>
                                </Card>
                            )}
                        </ModalBody>
                    </Modal>
                </CardFooter>
            </Card>
        </div>
    );
};

export default ORConsentFileList;